var formatter = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export function updateCart(e) {
    let id = e.target.dataset.id;
    let quantity = e.target.value;

    if (quantity < 1){
        e.target.value = 1;
        e.preventDefault();
        return;
    }

    console.log(id);
    console.log(quantity);

    cart.getItem(id).then(item => {

        let productObj = {quantity: parseInt(quantity)};

        if (item === null) {
            cart.addItem(id, productObj).then(state => {

            });
        } else {
            cart.updateItem(id, productObj).then(state => {
                document.getElementById('subtotal').innerHTML = formatter.format(state.items_subtotal_price / 100);
            });
        }
    })
}

export function format(amount){
    return formatter.format(amount / 100);
}